export function isFormattedFinalTurn(message) {
  return Boolean(
    message?.end_of_turn === true && message?.turn_is_formatted === true
  );
}

// A final re-transcribes the whole turn, so it may legitimately be shorter
// than the last interim the user watched (entity formatting: "twenty five
// thousand dollars" -> "$25,000"). Losing more than half of a substantial
// transcript is not formatting — treat it as a truncated final and keep the
// longer text. Interims under the floor are too short for the ratio to be
// meaningful (entity compression alone can halve them).
const TRANSCRIPT_SHRINK_GUARD_MIN_CHARS = 40;
const TRANSCRIPT_SHRINK_GUARD_RATIO = 0.5;

function normalizedTranscriptLength(value) {
  return typeof value === "string"
    ? value.replace(/\s+/g, " ").trim().length
    : 0;
}

export function isSuspiciousTranscriptShrink(previousText, nextText) {
  const previousLength = normalizedTranscriptLength(previousText);
  const nextLength = normalizedTranscriptLength(nextText);

  if (nextLength === 0) return previousLength > 0;
  if (previousLength < TRANSCRIPT_SHRINK_GUARD_MIN_CHARS) return false;
  return nextLength < previousLength * TRANSCRIPT_SHRINK_GUARD_RATIO;
}
